<template>
<div class="xiannong-footer">
    <div class="footer-content">
        <div class="footer-grid">
            <!-- 田园简介 -->
            <div class="footer-section">
                <div class="footer-title-area">
                    <div class="footer-icon">🌾</div>
                    <h3 class="footer-title">闲农日季</h3>
                </div>
                <p class="footer-desc">
                    记录田园生活，分享自然美好。在这里，我们耕耘土地，播种希望，收获快乐，用文字和照片记录每一天的田园时光。
                </p>
                <div class="footer-social">
                    <div v-for="social in socialLinks" :key="social.name" 
                         class="social-icon" 
                         :style="{backgroundColor: social.color}"
                         @click="handleSocialClick(social)">
                        <div class="social-symbol">{{ social.symbol }}</div>
                    </div>
                </div>
            </div>

            <!-- 田园导航 -->
            <div class="footer-section">
                <h3 class="footer-title">田园<span class="highlight">导航</span></h3>
                <div class="footer-links">
                    <router-link v-for="link in quickLinks" :key="link.path" :to="link.path" class="footer-link">
                        <span class="link-icon">🌱</span>
                        <span class="link-text">{{ link.text }}</span>
                    </router-link>
                </div>
            </div>

            <!-- 联系我 -->
            <div class="footer-section">
                <h3 class="footer-title">联系<span class="highlight">我</span></h3>
                <div class="contact-info">
                    <div class="contact-item">
                        <div class="contact-icon">
                            <div class="icon-symbol">📍</div>
                        </div>
                        <div class="contact-detail">
                            <div class="contact-label">田园地址</div>
                            <div class="contact-value">湖北某乡村田园</div>
                        </div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-icon">
                            <div class="icon-symbol">📱</div>
                        </div>
                        <div class="contact-detail">
                            <div class="contact-label">联系电话</div>
                            <div class="contact-value">181-7134-8330</div>
                        </div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-icon">
                            <div class="icon-symbol">📧</div>
                        </div>
                        <div class="contact-detail">
                            <div class="contact-label">联系邮箱</div>
                            <div class="contact-value">xiannong@life.com</div>
                        </div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-icon">
                            <div class="icon-symbol">🌞</div>
                        </div>
                        <div class="contact-detail">
                            <div class="contact-label">田园时间</div>
                            <div class="contact-value">日出而作，日落而息</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 田园风景 -->
            <div class="footer-section">
                <h3 class="footer-title">田园<span class="highlight">风景</span></h3>
                <div class="farm-scene">
                    <div class="scene-item" @click="showScene(1)">
                        <div class="scene-icon">🌻</div>
                        <div class="scene-text">向日葵田</div>
                    </div>
                    <div class="scene-item" @click="showScene(2)">
                        <div class="scene-icon">🍅</div>
                        <div class="scene-text">蔬菜园</div>
                    </div>
                    <div class="scene-item" @click="showScene(3)">
                        <div class="scene-icon">🌄</div>
                        <div class="scene-text">田园日落</div>
                    </div>
                    <div class="scene-item" @click="showScene(4)">
                        <div class="scene-icon">💦</div>
                        <div class="scene-text">雨后菜园</div>
                    </div>
                </div>
                <div class="weather-info">
                    <div class="weather-today">
                        <div class="weather-icon">☀️</div>
                        <div class="weather-detail">
                            <div class="weather-temp">24°C</div>
                            <div class="weather-desc">晴转多云</div>
                        </div>
                    </div>
                    <div class="weather-tip">适合播种和浇水</div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-bottom">
        <div class="footer-container">
            <div class="copyright">
                <p>&copy; 2024 闲农日季 田园生活日记 | 用心记录，用心生活</p>
                <p class="copyright-sub">遵循自然规律，享受田园时光</p>
            </div>
            <div class="bottom-links">
                <router-link to="/privacy" class="bottom-link">隐私政策</router-link>
                <span class="link-divider">·</span>
                <router-link to="/terms" class="bottom-link">服务条款</router-link>
                <span class="link-divider">·</span>
                <a href="javascript:;" class="bottom-link" @click="backToTop">回到顶部</a>
            </div>
        </div>
        <div class="nature-elements">
            <div class="footer-leaf" v-for="i in 8" :key="i" :style="getLeafStyle(i)"></div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'XiannongFooter',
    data() {
        return {
            quickLinks: [
                {
                    path: '/',
                    text: '首页'
                },
                {
                    path: '/about',
                    text: '关于我们'
                },
                {
                    path: '/support',
                    text: '技术支持'
                },
                {
                    path: '/privacy',
                    text: '隐私政策'
                },
                {
                    path: '/weather',
                    text: '天气农事'
                },
                {
                    path: '/garden',
                    text: '我的菜园'
                }
            ],
            socialLinks: [
                {
                    name: 'wechat',
                    symbol: '💬',
                    color: '#C8E6C9',
                    action: 'wechat'
                },
                {
                    name: 'weibo',
                    symbol: '🌐',
                    color: '#FFCDD2',
                    action: 'link',
                    url: 'https://weibo.com'
                },
                {
                    name: 'email',
                    symbol: '📧',
                    color: '#B3E5FC',
                    action: 'email'
                },
                {
                    name: 'share',
                    symbol: '🌱',
                    color: '#FFF9C4',
                    action: 'share'
                }
            ]
        }
    },
    methods: {
        handleSocialClick(social) {
            switch(social.action) {
                case 'wechat':
                    this.$message.success('请使用微信扫描二维码关注田园生活');
                    break;
                case 'email':
                    window.location.href = 'mailto:xiannong@life.com';
                    break;
                case 'link':
                    if (social.url) {
                        window.open(social.url, '_blank');
                    }
                    break;
                case 'share':
                    this.$message.success('感谢分享田园生活的美好！');
                    break;
            }
        },
        showScene(index) {
            const scenes = ['向日葵田', '蔬菜园', '田园日落', '雨后菜园'];
            this.$message.success(`查看${scenes[index-1]}美景`);
        },
        backToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        getLeafStyle() {
            const size = 8 + Math.random() * 16
            const rotation = Math.random() * 360
            const left = Math.random() * 100
            const delay = Math.random() * 5
            
            return {
                width: `${size}px`,
                height: `${size}px`,
                transform: `rotate(${rotation}deg)`,
                left: `${left}%`,
                animationDelay: `${delay}s`
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.xiannong-footer {
    background: linear-gradient(to bottom, #f9f7f0 0%, #e8f5e8 100%);
    color: #5a3921;
    padding: 60px 0 0;
    position: relative;
    border-top: 2px solid rgba(139, 195, 74, 0.2);

    &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(90deg, 
            transparent 0%, 
            #C8E6C9 20%, 
            #A5D6A7 50%, 
            #C8E6C9 80%, 
            transparent 100%);
    }
}

.footer-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.footer-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 40px;
    margin-bottom: 60px;
}

.footer-section {
    .footer-title-area {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 20px;

        .footer-icon {
            font-size: 32px;
            animation: gentleWave 4s ease-in-out infinite;
        }

        .footer-title {
            color: #5a3921;
            font-size: 20px;
            font-weight: 600;
            margin: 0;
            font-family: 'KaiTi', 'STKaiti', serif;
        }
    }

    .footer-desc {
        color: #8d6e63;
        line-height: 1.8;
        margin-bottom: 25px;
        font-size: 14px;
    }

    .footer-title {
        color: #5a3921;
        font-size: 18px;
        margin-bottom: 25px;
        padding-bottom: 10px;
        position: relative;
        font-weight: 600;

        .highlight {
            color: #4caf50;
            position: relative;
            
            &::after {
                content: '';
                position: absolute;
                bottom: 2px;
                left: 0;
                width: 100%;
                height: 6px;
                background: rgba(129, 199, 132, 0.2);
                z-index: -1;
                border-radius: 3px;
            }
        }

        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 40px;
            height: 2px;
            background: linear-gradient(to right, #81c784, transparent);
            border-radius: 1px;
        }
    }
}

@keyframes gentleWave {
    0%, 100% {
        transform: translateY(0) rotate(0deg);
    }
    50% {
        transform: translateY(-3px) rotate(2deg);
    }
}

.footer-social {
    display: flex;
    gap: 15px;

    .social-icon {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;

        .social-symbol {
            font-size: 20px;
            transition: all 0.3s ease;
        }

        &:hover {
            transform: translateY(-5px) scale(1.1);
            border-color: rgba(76, 175, 80, 0.3);
            box-shadow: 0 5px 15px rgba(139, 195, 74, 0.15);

            .social-symbol {
                transform: scale(1.2);
            }
        }
    }
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .footer-link {
        color: #8d6e63;
        text-decoration: none;
        font-size: 14px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        padding: 8px 0;
        border-radius: 6px;

        &:hover {
            color: #4caf50;
            background: rgba(129, 199, 132, 0.1);
            padding-left: 15px;
            transform: translateX(5px);

            .link-icon {
                transform: rotate(15deg) scale(1.2);
            }
        }

        .link-icon {
            font-size: 16px;
            margin-right: 10px;
            transition: all 0.3s ease;
        }

        .link-text {
            flex: 1;
        }
    }
}

.contact-info {
    display: flex;
    flex-direction: column;
    gap: 18px;

    .contact-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        transition: all 0.3s ease;
        padding: 10px;
        border-radius: 8px;

        &:hover {
            background: rgba(129, 199, 132, 0.1);
            transform: translateX(3px);
        }

        .contact-icon {
            width: 36px;
            height: 36px;
            background: rgba(129, 199, 132, 0.15);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;

            .icon-symbol {
                font-size: 18px;
            }
        }

        .contact-detail {
            flex: 1;

            .contact-label {
                font-size: 12px;
                color: #a1887f;
                margin-bottom: 2px;
            }

            .contact-value {
                font-size: 14px;
                color: #5a3921;
                font-weight: 500;
            }
        }
    }
}

.farm-scene {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-bottom: 25px;

    .scene-item {
        background: rgba(255, 255, 255, 0.9);
        border-radius: 10px;
        padding: 15px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 2px solid transparent;
        box-shadow: 0 3px 10px rgba(139, 195, 74, 0.1);

        &:hover {
            transform: translateY(-5px);
            border-color: #c8e6c9;
            box-shadow: 0 8px 20px rgba(139, 195, 74, 0.15);
            background: rgba(200, 230, 201, 0.1);

            .scene-icon {
                transform: scale(1.2);
                animation: gentleWave 1s ease-in-out;
            }
        }

        .scene-icon {
            font-size: 28px;
            margin-bottom: 8px;
            transition: all 0.3s ease;
            display: inline-block;
        }

        .scene-text {
            font-size: 12px;
            color: #8d6e63;
            font-weight: 500;
        }
    }
}

.weather-info {
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    padding: 15px;
    border: 2px solid rgba(168, 230, 207, 0.5);
    box-shadow: 0 3px 15px rgba(139, 195, 74, 0.1);

    .weather-today {
        display: flex;
        align-items: center;
        gap: 15px;
        margin-bottom: 10px;

        .weather-icon {
            font-size: 36px;
            animation: sunGlow 3s ease-in-out infinite;
        }

        .weather-detail {
            .weather-temp {
                font-size: 24px;
                font-weight: 600;
                color: #5a3921;
                line-height: 1;
            }

            .weather-desc {
                font-size: 14px;
                color: #8d6e63;
            }
        }
    }

    .weather-tip {
        font-size: 12px;
        color: #4caf50;
        font-weight: 500;
        padding: 8px 12px;
        background: rgba(129, 199, 132, 0.1);
        border-radius: 6px;
        text-align: center;
        border-left: 3px solid #4caf50;
    }
}

@keyframes sunGlow {
    0%, 100% {
        transform: scale(1);
        opacity: 0.9;
    }
    50% {
        transform: scale(1.1);
        opacity: 1;
    }
}

.footer-bottom {
    background: linear-gradient(to bottom, rgba(233, 245, 233, 0.5), rgba(205, 220, 205, 0.3));
    padding: 25px 0;
    border-top: 1px solid rgba(139, 195, 74, 0.3);
    position: relative;
    overflow: hidden;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    position: relative;
    z-index: 2;
}

.copyright {
    p {
        color: #8d6e63;
        font-size: 14px;
        margin: 0 0 5px;
        font-weight: 500;
    }

    .copyright-sub {
        font-size: 12px;
        color: #a1887f;
    }
}

.bottom-links {
    display: flex;
    align-items: center;
    gap: 15px;

    .bottom-link {
        color: #8d6e63;
        text-decoration: none;
        font-size: 13px;
        transition: all 0.3s ease;
        font-weight: 500;

        &:hover {
            color: #4caf50;
            text-decoration: underline;
        }
    }

    .link-divider {
        color: #c8e6c9;
        font-weight: bold;
    }
}

.nature-elements {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;

    .footer-leaf {
        position: absolute;
        background: linear-gradient(45deg, #C8E6C9, #A5D6A7);
        clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        opacity: 0.3;
        animation: leafFloat 15s infinite linear;
    }
}

@keyframes leafFloat {
    0%, 100% {
        transform: translateY(0) translateX(0) rotate(0deg);
        opacity: 0.3;
    }
    50% {
        transform: translateY(-30px) translateX(20px) rotate(180deg);
        opacity: 0.1;
    }
}

@media (max-width: 992px) {
    .footer-grid {
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 30px;
    }
}

@media (max-width: 768px) {
    .xiannong-footer {
        padding: 40px 0 0;
    }

    .footer-grid {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .footer-container {
        flex-direction: column;
        text-align: center;
        gap: 15px;
    }

    .bottom-links {
        justify-content: center;
    }

    .farm-scene {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 576px) {
    .footer-section {
        text-align: center;

        .footer-title-area {
            justify-content: center;
        }

        .footer-title::after {
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .contact-item {
        flex-direction: column;
        align-items: center;
        text-align: center;

        .contact-icon {
            margin-bottom: 8px;
        }
    }

    .footer-social {
        justify-content: center;
    }
}
</style>